<template>
<div class="container">
  <Header />
  <validation-observer ref="obs" v-slot="ObserverProps">
    <b-form-group label="名前（漢字）" description="名前の漢字表記が存在しない場合は、半角アルファベット表記を入力してください。">
      <validation-provider name="name" rules="required">
        <b-form-input v-model="user.name" placeholder="東大太郎"></b-form-input>
      </validation-provider>
    </b-form-group>
    <b-form-group label="名前（かな）" description="">
      <validation-provider name="kana" rules="required">
        <b-form-input v-model="user.kana" placeholder="とうだいたろう"></b-form-input>
      </validation-provider>
    </b-form-group>
    <b-form-group label="かるた会に入った年度" description="">
      <validation-provider name="enterYear" rules="required">
        <b-form-input v-model="user.enterYear" number maxlength=4 placeholder="1983"></b-form-input>
      </validation-provider>
    </b-form-group>
    <b-form-group label="メールアドレス" description="">
      <validation-provider name="email" rules="required">
        <b-form-input v-model="user.email" disabled></b-form-input>
      </validation-provider>
    </b-form-group>
    <b-button variant="success" size="sm" class="my-2 mx-2 float-right" @click="update()" :disabled="ObserverProps.invalid">利用申請</b-button>
  </validation-observer>
</div>
</template>

<style>
.label {
  margin-bottom: 0rem
}
</style>

<script>
import Header from '../components/Header.vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import router from '../router'
import dayjs from 'dayjs'
import {
  ValidationProvider,
  extend
} from "vee-validate";
import {
  required
} from "vee-validate/dist/rules";
extend('required', required);

export default {
  name: 'applying',
  components: {
    Header,
    ValidationProvider,
  },
  data() {
    return {
      user: {
        name: "",
        kana: ''
      },
      auth: {}
    }
  },
  created: function() {
    this.database = firebase.database();
    this.auth = firebase.auth()
    this.uid = firebase.auth().currentUser.uid;
    firebase.database().ref('users/' + firebase.auth().currentUser.uid).on("value", snapShot => {
      if (snapShot) {
        snapShot.forEach((data) => {
          this.user[data.key] = data.val()
        })
      }
    })
    this.user["email"] = firebase.auth().currentUser.email
  },
  methods: {
    logout() {
      firebase.auth().signOut().then(function() {
        router.push('/')
      }).catch(error => {
        console.log(error.message)
        router.push('/')
      })
    },
    update() {
      const now = dayjs();
      console.log(now)
      this.user["lastUpdateDate"] = now.unix();
      firebase.database().ref('users/' + firebase.auth().currentUser.uid).update(this.user)
      alert("申請ありがとうございます。管理者が承認するまでお待ちください。")
    }
  },
}
</script>
